import "../../stylesheets/PopupRegister.css";
import React from "react";
import { useNavigate } from "react-router-dom";

function PopupRegister({ user }) {
  const navigate = useNavigate();

  const handleEnter = () => {
    const email = user?.email;
    if (email) {
      localStorage.setItem("user-email", JSON.stringify(email));
    }
    navigate("/validate-email");
  };

  return (
    <>
      <div className="popup-register-container">
        <div className="popup">
          <div className="red">
            <img
              src={process.env.PUBLIC_URL + "/images/stage_characters/Popup_Imagen.png"}
              alt=""
            />
          </div>
          <h1>Usuario creado con éxito</h1>
          <h2>
            ¡Por favor valide su bandeja de entrada en su correo electrónico para comenzar a jugar!
            <br />
            ¡NO OLVIDES REVISAR EL SPAM!
          </h2>
          <button className="btn red-btn" onClick={handleEnter}>
            Entrar
          </button>
        </div>
      </div>
    </>
  );
}

export default PopupRegister;
